import React, { useState, useRef, useEffect } from "react";
import { MoreHorizontal } from "lucide-react";
import Tooltip from "../../../../../components/Tooltip/Tooltip";

interface Props {
  onShareReport: () => void;
  onScheduleReport: () => void;
  onAddToGroup: () => void;
  onAddToManagementReports: () => void;
}

export default function MoreActionsMenu({ onShareReport, onScheduleReport, onAddToGroup, onAddToManagementReports }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <Tooltip label="More actions">
        <button type="button" onClick={() => setOpen((o) => !o)} className="w-8 h-8 rounded-md inline-flex items-center justify-center text-ink2 hover:bg-[#EEF4FB] hover:text-ink">
          <MoreHorizontal className="w-4 h-4" />
        </button>
      </Tooltip>
      {open && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-[#D8DEE6] rounded-lg shadow-lg z-50 py-1 min-w-[240px]">
          <Item onClick={() => { onShareReport(); setOpen(false); }}>Share report</Item>
          <Item onClick={() => { onScheduleReport(); setOpen(false); }}>Schedule report</Item>
          <Item onClick={() => { onAddToGroup(); setOpen(false); }}>Add to group</Item>
          <Item onClick={() => { onAddToManagementReports(); setOpen(false); }}>Add to management reports</Item>
        </div>
      )}
    </div>
  );
}

function Item({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
  return <button type="button" onClick={onClick} className="w-full text-left px-3.5 py-2 text-[12.5px] text-ink hover:bg-[#EEF4FB]">{children}</button>;
}